import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'tutorial',
    templateUrl: './cadastre-solaire-tutorial-modal.template.html',
    standalone: false,
})
export class CadastreSolaireTutorialModalComponent {
    @Input() public separator: boolean = true;
    @Input() public profileName!: string;

    constructor(public activeModal: NgbActiveModal) {}
}
